import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute } from '@angular/router';
import { MarcasService } from '../_services/marcas.service';
import { Marcas } from '../_model/marcas';

@Component({
    selector: 'app-gestaoPratas',
    templateUrl: './gestaoPratas.component.html',
    styleUrls: ['./gestaoPratas.component.less'],
    standalone: false
})
export class GestaoPratasComponent implements OnInit {

  constructor(private marca: MarcasService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if(params['marca']=='true') {
        this.links = [{link: 'admin', name: 'Administração'},{link: 'admin/marcas', name: 'Inserir Marcas'},{link: 'admin/gestaoMarcas', name: 'Gestão de Marcas'}]
      }
    });
  }
  links: any[] = [{link: 'admin', name: 'Administração'},{link: 'admin/gestaoMarcas', name: 'Gestão de Marcas'}];
  marcas: Marcas[] = [];

  ngOnInit() {
    this.marca.listPathOrder('prata').subscribe((data: any[]) => {
      data.forEach((el: Marcas) => {
        this.marcas.push(new Marcas(el));
      })
    });
  }

  drop(event: CdkDragDrop<Marcas[]>) {
    moveItemInArray(this.marcas, event.previousIndex, event.currentIndex);
    this.marca.sendOrder('prata',this.marcas).subscribe();
  }
}

